var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 3.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#1B2831"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 3.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#1B2831"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#1B2831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.a7953594f052be48ef976237ea005e82.svg";
export { ForwardRef as ReactComponent };